
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/locations/browse",
      function () {
        return require("private-next-pages/stores/[cName]/locations/browse.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/locations/browse"])
      });
    }
  